import React from 'react';

import StarIcon from '@mui/icons-material/Star';
import { Chip, useTheme } from '@mui/material';
import { TagCategory } from 'src/services/panacea/types';
import { DisplayFilters } from 'src/utils/filters/display-filters';

type Props = {
  topRatedByUserCategory: TagCategory;
  selectedFilters: DisplayFilters;
  setSelectedFilters: React.Dispatch<React.SetStateAction<DisplayFilters>>;
};

const TopRatedFilter: React.FC<Props> = ({
  topRatedByUserCategory,
  selectedFilters,
  setSelectedFilters,
}) => {
  const theme = useTheme();

  // Checking for the presence of the category is insufficient due to the "Reset" functionality,
  // which clears out the tags within the category but keeps the tag category itself.
  const isSelected = !!selectedFilters.tagCategories?.some((tc) =>
    tc.tags.some((tag) => tag.logicalId === 'TOP_RATED_BY_USER'),
  );

  const handleToggle = () => {
    setSelectedFilters((prevState) => {
      if (isSelected) {
        return {
          ...prevState,
          tagCategories: prevState.tagCategories?.filter(
            (tc) => tc.logicalId !== 'TOP_RATED_BY_USER',
          ),
        };
      }
      return {
        ...prevState,
        tagCategories: [
          ...(prevState.tagCategories || []),
          topRatedByUserCategory,
        ],
      };
    });
  };

  return (
    <Chip
      label={topRatedByUserCategory.tags[0].displayName}
      icon={
        <StarIcon
          sx={{
            fontSize: '14px !important',
            color: isSelected
              ? `${theme.palette.primary.contrastText} !important`
              : `${theme.palette.text.primary} !important`,
          }}
        />
      }
      style={{
        margin: '0 0.35rem 0 0',
        borderRadius: 4,
        fontSize: '0.875rem',
        padding: '6px 8px',
        columnGap: 6,
      }}
      sx={{
        '& .MuiChip-label': { padding: '2px' },
      }}
      size="medium"
      color={isSelected ? 'primary' : 'default'}
      onClick={handleToggle}
    />
  );
};

export default TopRatedFilter;
